export const sortProviderFavorites = (data: any) => {
  return data.sort(
    (a, b) =>
      a.type.toLowerCase().localeCompare(b.type.toLowerCase()) ||
      a.providerRole.toLowerCase().localeCompare(b.providerRole.toLowerCase()) ||
      a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase())
  );
};